import { createFeatureSelector, createSelector } from '@ngrx/store';
import { SerpApiState } from './serpApi.reducer';

export const selectSerpApiState = createFeatureSelector<SerpApiState>('serpApi');

export const selectLocations = createSelector(
  selectSerpApiState,
  (state: SerpApiState) => state.locations
);

export const selectDomains = createSelector(
  selectSerpApiState,
  (state: SerpApiState) => state.domains
);

export const selectLanguages = createSelector(
  selectSerpApiState,
  (state: SerpApiState) => state.languages
);

export const selectLoading = createSelector(
  selectSerpApiState,
  (state: SerpApiState) => state.loading
);

export const selectError = createSelector(
  selectSerpApiState,
  (state: SerpApiState) => state.error
);
